<template>
    <div>
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title text-center">
                    Datos personales titular o codeudor
                </h6>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Primer nombre </label>
                    <fg-input   
                                tabindex="1"
                                type="text"
                                name="nombre de cliente"
                                autocomplete="off"
                                :error="getError('nombre de cliente')"
                                v-model="customerFirstName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Segundo nombre </label>
                    <fg-input   
                                tabindex="1"
                                type="text"
                                name="segundo nombre de cliente"
                                autocomplete="off"
                                :error="getError('segundo nombre de cliente')"
                                v-model="customerSecondName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Primer apellido </label>
                    <fg-input   
                                tabindex="1"
                                type="text"
                                name="apellido de cliente"
                                autocomplete="off"
                                :error="getError('apellido de cliente')"
                                v-model="customerSurname">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Segundo apellido </label>
                    <fg-input   
                                tabindex="1"
                                type="text"
                                name="segundo apellido de cliente"
                                autocomplete="off"
                                :error="getError('segundo apellido de cliente')"
                                v-model="customerSecondSurname">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Número de identificación </label>
                    <fg-input   
                                tabindex="2"
                                type="number"
                                name="número de identificación"
                                autocomplete="off"
                                :error="getError('número de identificación')"
                                v-model="customerIdentificationNumber">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Tipo de identificación </label>
                    <fg-input   tabindex="3"
                                name="tipo de identificación"
                                :error="getError('tipo de identificación')"
                                v-model="customerIdentificationType">
                            <el-select
                                     
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="customerIdentificationType">
                            <el-option v-for="identificationDocumentType in $store.getters.getIdentificationDocumentTypes" :key="identificationDocumentType.id"
                                    class="select-warning"
                                    :value="identificationDocumentType.id"
                                    :label="identificationDocumentType.name">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <h6 style="color: white;">
                    Lugar y fecha de nacimiento
                </h6>
                                <div class="form-group">
                    <label>País</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="pais cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.country"
                                :error="getError('pais cliente')"
                                v-model="form.customer.country">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Departamento</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="departamento cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.state"
                                :error="getError('departamento cliente')"
                                v-model="form.customer.state">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Municipio</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="municipio cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.city"
                                :error="getError('municipio cliente')"
                                v-model="form.customer.city">
                    </fg-input>
                </div>
                <!-- <div class="form-group">
                    <label>Fecha</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="fecha de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.date"
                                :error="getError('fecha de cliente')"
                                v-model="form.customer.date">
                    </fg-input>
                </div> -->
                <div class="form-group">
                    <label>Fecha de nacimiento</label>
                    <el-date-picker
                        format="dd/MM/yyyy"
                        v-model="form.customer.date"
                        type="date"
                        placeholder="Seleccione fecha de nacimiento">
                    </el-date-picker>
                </div>
                <div class="form-group">
                    <label>Nacionalidad</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nacionalidad de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.nationality"
                                :error="getError('nacionalidad de cliente')"
                                v-model="form.customer.nationality">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Estado civil </label>
                    <fg-input   tabindex="3"
                                name="estado civil"
                                v-validate="modelValidations.customer.civil_status"
                                :error="getError('estado civil')"
                                v-model="form.customer.civil_status">
                            <el-select 
                                    v-model="form.customer.civil_status"
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione">
                            <el-option class="select-warning"
                                    value = "Soltero"
                                    label="SOLTERO">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Unión Libre"
                                    label="UNIÓN LIBRE">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Casado"
                                    label="CASADO">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Personas a cargo</label>
                    <fg-input   tabindex="1"
                                type="number"
                                name="personas a cargo"
                                autocomplete="off"
                                v-validate="modelValidations.customer.people"
                                :error="getError('personas a cargo')"
                                v-model="form.customer.people">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Nivel educativo </label>
                    <fg-input   tabindex="3"
                                name="nivel educativo"
                                v-validate="modelValidations.customer.educational_level"
                                :error="getError('nivel educativo')"
                                v-model="form.customer.educational_level">
                            <el-select 
                                    v-model="form.customer.educational_level"
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione">
                            <el-option class="select-warning"
                                    value = "Primaria"
                                    label="PRIMARIA">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Bachillerato"
                                    label="BACHILLERATO">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Técnico"
                                    label="TÉCNICO">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Tecnólogo"
                                    label="TECNÓLOGO">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Universitario"
                                    label="UNIVERSITARIO">
                            </el-option>
                            <!-- <el-option class="select-warning"
                                    value = "Profesional"
                                    label="PROFESIONAL">
                            </el-option> -->
                            <el-option class="select-warning"
                                    value = "Postgrado"
                                    label="POSGRADO">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Ninguno"
                                    label="NINGUNO">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Descripción de la actividad principal </label>
                    <fg-input   tabindex="3"
                                name="descripción act. principal"
                                v-validate="modelValidations.customer.principal_activity"
                                :error="getError('descripción act. principal')"
                                v-model="form.customer.principal_activity">
                            <el-select 
                                    v-model="form.customer.principal_activity"
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione">
                            <el-option v-if="validateStudy() == 'consumer'" class="select-warning"
                                    value = "Dependiente-Empleado"
                                    label="Dependiente-Empleado">
                            </el-option>
                            <el-option v-if="validateStudy() == 'micro' || validateStudy() == 'pyme' || validateStudy() == 'agro'" class="select-warning"
                                    value = "Independiente"
                                    label="Independiente">
                            </el-option>
                            <el-option v-if="validateStudy() == 'consumer'" class="select-warning"
                                    value = "Pensionado"
                                    label="Pensionado">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Descripción de la actividad económica </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="descripción actividad económica"
                                autocomplete="off"
                                v-validate="modelValidations.customer.economic_description"
                                :error="getError('descripción actividad económica')"
                                v-model="form.customer.economic_description">
                    </fg-input>
                </div>
                <!-- <div class="form-group">
                    <label>CIIU</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="ciiu cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.ciiu"
                                :error="getError('ciiu cliente')"
                                v-model="form.customer.ciiu">
                    </fg-input>
                </div> -->
                <div class="form-group">
                    <label>CIIU</label>
                    <fg-input   tabindex="1"
                                name="ciiu cliente"
                                v-validate="modelValidations.customer.ciiu"
                                :error="getError('ciiu cliente')"
                                v-model="form.customer.ciiu">
                            <el-select
                                    filterable
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="form.customer.ciiu">
                            <el-option v-for="activity in $store.getters.getEconomicActivities" :key="activity.code"
                                    class="select-warning"
                                    :value="activity.code"
                                    :label="activity.code+' - '+activity.name">
                                    <span style="float: left">{{ activity.code }} - {{ activity.name }}</span>
                                    <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ activity.code }}</span> -->
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <!-- <div class="form-group">
                    <label>Categoría Profesión</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="categoría profesión cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.ocupation_category"
                                :error="getError('categoría profesión cliente')"
                                v-model="form.customer.ocupation_category">
                    </fg-input>
                </div> -->
                <!-- <div class="form-group">
                    <label>Profesión</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="profesión cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.ocupation"
                                :error="getError('profesión cliente')"
                                v-model="form.customer.ocupation">
                    </fg-input>
                </div> -->
                <div class="form-group">
                    <label>¿Es usted una persona con discapacidad?</label>
                    <fg-input   tabindex="1"
                                name="persona discapacidad"
                                v-validate="modelValidations.customer.disability_person"
                                :error="getError('persona discapacidad')"
                                v-model="form.customer.disability_person">
                            <el-select 
                                    v-model="form.customer.disability_person"
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione">
                            <el-option class="select-warning"
                                    value = "1"
                                    label="SI">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "2"
                                    label="NO">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-show="form.customer.disability_person == '1'" class="form-group">
                    <label>¿Cuál discapacidad?</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="descripción discapacidad"
                                autocomplete="off"
                                v-validate="modelValidations.customer.disability_description"
                                :error="getError('descripción discapacidad')"
                                v-model="form.customer.disability_description">
                    </fg-input>
                </div>


                <div class="form-group">
                    <label>Profesión </label>
                    <fg-input   tabindex="1"
                                name="profesión"
                                v-validate="modelValidations.customer.ocupation"
                                :error="getError('profesión')"
                                v-model="form.customer.ocupation">
                            <el-select
                                    filterable
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="form.customer.ocupation">
                            <el-option v-for="profession in $store.getters.getProfessions" :key="profession.code"
                                    class="select-warning"
                                    :value="profession.name"
                                    :label="profession.name">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Oficio</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="oficio cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.job"
                                :error="getError('oficio cliente')"
                                v-model="form.customer.job">
                    </fg-input>
                </div>
                <!-- <div class="form-group">
                    <label>Sector </label>
                    <fg-input   tabindex="3"
                                name="tipo de vínculo"
                                v-validate="modelValidations.requestData"
                                :error="getError('tipo de vínculo')"
                                v-model="form.customer.activity_type">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione">
                            <el-option class="select-warning"
                                    value = "1"
                                    label="Titular">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "2"
                                    label="Codeudor">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "3"
                                    label="cónyuge codeudor">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div> -->
                <div class="form-group">
                    <label>Correo electrónico</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="correo de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.email"
                                :error="getError('correo de cliente')"
                                v-model="form.customer.email">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Dirección de vivienda</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="dirección de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.address"
                                :error="getError('dirección de cliente')"
                                v-model="form.customer.address">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Estrato</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="estrato de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.stratum"
                                :error="getError('estrato de cliente')"
                                v-model="form.customer.stratum">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Departamento</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="departamento vivienda de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.house_state"
                                :error="getError('departamento vivienda de cliente')"
                                v-model="form.customer.house_state">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Municipio</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="municipio vivienda de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.house_city"
                                :error="getError('municipio vivienda de cliente')"
                                v-model="form.customer.house_city">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Barrio/Vereda</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="barrio de vivienda de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.house_neighborhood"
                                :error="getError('barrio de vivienda de cliente')"
                                v-model="form.customer.house_neighborhood">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Código</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="código de barrio de vivienda de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.house_neighborhood_code"
                                :error="getError('código de barrio de vivienda de cliente')"
                                v-model="form.customer.house_neighborhood_code">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Ubicación de la vivienda</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="ubicación de vivienda de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.house_description"
                                :error="getError('ubicación de vivienda de cliente')"
                                v-model="form.customer.house_description">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono fijo de vivienda</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono vivienda de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.house_phone"
                                :error="getError('teléfono vivienda de cliente')"
                                v-model="form.customer.house_phone">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono celular</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="celular vivienda de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.house_celphone"
                                :error="getError('celular vivienda de cliente')"
                                v-model="form.customer.house_celphone">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Tipo de vivienda </label>
                    <fg-input   tabindex="3"
                                name="tipo vivienda cliente"
                                v-validate="modelValidations.customer.house_type"
                                :error="getError('tipo vivienda cliente')"
                                v-model="form.customer.house_type">
                            <el-select 
                                    v-model="form.customer.house_type"
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione">
                            <el-option class="select-warning"
                                    value = "Propia"
                                    label="PROPIA">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Alquilada"
                                    label="ALQUILADA">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Familiar"
                                    label="FAMILIAR">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Habitada desde</label>
                    <el-date-picker
                        format="dd/MM/yyyy"
                        v-model="form.customer.in_house_since"
                        type="date"
                        placeholder="Seleccione fecha">
                    </el-date-picker>
                </div>
                <div v-if="form.customer.house_type == 'Alquilada'" class="form-group">
                    <label>Nombre de arrendador</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="arrendador cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.house_lessor"
                                :error="getError('arrendador cliente')"
                                v-model="form.customer.house_lessor">
                    </fg-input>
                </div>
                <div v-if="form.customer.house_type == 'Alquilada'" class="form-group">
                    <label>Teléfono del arrendador</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono arrendador cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.house_lessor_phone"
                                :error="getError('teléfono arrendador cliente')"
                                v-model="form.customer.house_lessor_phone">
                    </fg-input>
                </div>
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button @click="saveData()" type="warning">Guardar</p-button>
                    <p-button @click="toMenu()" type="default" class="pull-left mb-3">Atrás</p-button>
                </div>
            </div>
        </card>
        <card v-if="form.customer.principal_activity == 'Dependiente-Empleado' && showForm('Dependiente')" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title text-center">
                    Datos laborales solo para dependientes - empleados
                </h6>
                <div  class="alert alert-info text-center">
                    <span >No aplica para pensionados e independientes</span>
                </div>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Cargo que ocupa en la empresa </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="cargo de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.dependent.job"
                                :error="getError('cargo de cliente')"
                                v-model="form.customer.dependent.job">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>NIT de la empresa </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nit empresa de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.dependent.job_nit"
                                :error="getError('nit empresa de cliente')"
                                v-model="form.customer.dependent.job_nit">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Nombre de la empresa </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="empresa de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.dependent.job_name"
                                :error="getError('empresa de cliente')"
                                v-model="form.customer.dependent.job_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Departamento </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="departamento empresa de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.dependent.job_state"
                                :error="getError('departamento empresa de cliente')"
                                v-model="form.customer.dependent.job_state">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Municipio </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="municipio empresa de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.dependent.job_city"
                                :error="getError('municipio empresa de cliente')"
                                v-model="form.customer.dependent.job_city">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Barrio </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="barrio empresa de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.dependent.job_neighborhood"
                                :error="getError('barrio empresa de cliente')"
                                v-model="form.customer.dependent.job_neighborhood">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Código </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="código barrio empresa de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.dependent.job_neighborhood_code"
                                :error="getError('código barrio empresa de cliente')"
                                v-model="form.customer.dependent.job_neighborhood_code">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono de la empresa </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono empresa de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.dependent.job_phone"
                                :error="getError('teléfono empresa de cliente')"
                                v-model="form.customer.dependent.job_phone">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Dirección de la empresa </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="descripción empresa de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.dependent.job_address"
                                :error="getError('descripción empresa de cliente')"
                                v-model="form.customer.dependent.job_address">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Tipo de contrato </label>
                    <fg-input   tabindex="3"
                                name="tipo de contrato"
                                v-validate="modelValidations.customer.dependent.contract_type"
                                :error="getError('tipo de contrato')"
                                v-model="form.customer.dependent.contract_type">
                            <el-select 
                                    v-model="form.customer.dependent.contract_type"
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione">
                            <el-option class="select-warning"
                                    value = "Fijo"
                                    label="FIJO">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Indefinido"
                                    label="INDEFINIDO">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Obra o Labor"
                                    label="OBRA LABOR">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Prestación de Servicios"
                                    label="PRESTACIÓN DE SERVICIOS">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <!-- <div class="form-group">
                    <label>Fecha ingreso </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="fecha ingreso de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.dependent.date"
                                :error="getError('fecha ingreso de cliente')"
                                v-model="form.customer.dependent.date">
                    </fg-input>
                </div> -->
                <div class="form-group">
                    <label>Fecha ingreso</label>
                    <el-date-picker
                        format="dd/MM/yyyy"
                        v-model="form.customer.dependent.date"
                        type="date"
                        placeholder="Seleccione fecha de ingreso">
                    </el-date-picker>
                </div>
                <div class="form-group">
                    <label>Unicación de la empresa </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="ubicación empresa de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.dependent.job_description"
                                :error="getError('ubicación empresa de cliente')"
                                v-model="form.customer.dependent.job_description">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Nombre del jefe inmediato </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="jefe de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.dependent.job_boss"
                                :error="getError('jefe de cliente')"
                                v-model="form.customer.dependent.job_boss">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono celular del jefe inmediato </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono jefe de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.dependent.job_boss_phone"
                                :error="getError('teléfono jefe de cliente')"
                                v-model="form.customer.dependent.job_boss_phone">
                    </fg-input>
                </div>
                <!-- <div v-if="activity_type_computed == 'PRODUCCIÓN'" class="form-group">
                    <label>Subcategoría </label>
                    <fg-input   name="subcategoría"
                                v-validate="modelValidations.requestData"
                                :error="getError('subcategoría')"
                                v-model="customerStudySubcategory">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="customerStudySubcategory">
                            <el-option 
                                    class="select-warning"
                                    value="produccion"
                                    label="Producción">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div> -->
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button @click="saveData()" type="warning">Guardar</p-button>
                    <!-- <p-button @click="toPersonalData()" type="default" class="pull-left mb-3">Atrás</p-button> -->
                </div>
            </div>
        </card>
        <card v-if="form.customer.principal_activity == 'Independiente' && showForm('Independiente')" class="form-horizontal">
        <!-- <card class="form-horizontal"> -->
            <div class="card-header">
                <h6 class="card-title text-center">
                    Datos de la actividad o negocio
                </h6>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Nombre del negocio </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="negocio de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.independent.business_name"
                                :error="getError('negocio de cliente')"
                                v-model="form.customer.independent.business_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Actividad específica del negocio </label>
                    <fg-input   tabindex="1"
                                name="ciiu cliente"
                                v-validate="modelValidations.customer.independent.business_activity"
                                :error="getError('ciiu cliente')"
                                v-model="form.customer.independent.business_activity">
                            <el-select
                                    filterable
                                    clearable
                                    class="select-warning"
                                    size="mini"
                                    placeholder="Seleccione..."
                                    v-model="form.customer.independent.business_activity">
                            <el-option v-for="activity in $store.getters.getEconomicActivities" :key="activity.code"
                                    @change="changeCIIUIndependent(activity.code)"
                                    class="select-warning"
                                    :value="activity.name"
                                    :label="activity.code+' - '+activity.name">
                                    <span style="float: left">{{ activity.code }} - {{ activity.name }}</span>
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <!-- <div class="form-group">
                    <label>Actividad específica del negocio </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="actividad de negocio de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.independent.business_activity"
                                :error="getError('actividad de negocio de cliente')"
                                v-model="form.customer.independent.business_activity">
                    </fg-input>
                </div> -->
                <div class="form-group">
                    <label>Código CIIU </label>
                    <fg-input   tabindex="1"
                                disabled
                                type="text"
                                name="ciiu negocio de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.independent.business_ciiu"
                                :error="getError('ciiu negocio de cliente')"
                                v-model="form.customer.independent.business_ciiu">
                    </fg-input>
                </div>
                <!-- <div class="form-group">
                    <label>CIIU </label>
                    <fg-input   tabindex="1"
                                name="ciiu cliente"
                                v-validate="modelValidations.customer.independent.business_ciiu"
                                :error="getError('ciiu cliente')"
                                v-model="form.customer.independent.business_ciiu">
                            <el-select
                                    filterable
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="form.customer.independent.business_ciiu">
                            <el-option v-for="activity in $store.getters.getEconomicActivities" :key="activity.code"
                                    class="select-warning"
                                    :value="activity.name"
                                    :label="activity.code+' - '+activity.name">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div> -->
                <h6 style="color: white;">
                    Ubicación del negocio
                </h6>
                <div class="form-group">
                    <label>Urbano</label>
                    <fg-input   tabindex="3"
                                name="urbano"
                                v-validate="modelValidations.customer.independent.business_type_location"
                                :error="getError('urbano')"
                                v-model="form.customer.independent.business_type_location">
                            <el-select 
                                    v-model="form.customer.independent.business_type_location"
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione">
                            <el-option class="select-warning"
                                    value = "Plaza de Mercado"
                                    label="PLAZA DE MERCADO">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Local Comercial"
                                    label="LOCAL COMERCIAL">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Itinerante"
                                    label="ITINERANTE">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Ambulante"
                                    label="AMBULANTE">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Residencia"
                                    label="RESIDENCIA">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <br>
                <div  class="row" style="margin: 0 0 12px;">
                    <p-checkbox v-model="form.customer.independent.business_rural" value="1" :checked="false">Rural </p-checkbox>
                </div>
                <!-- <div class="form-group">
                    <label>Funcionamiento desde</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="funcionamiento desde negocio cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.independent.business_since"
                                :error="getError('funcionamiento desde negocio cliente')"
                                v-model="form.customer.independent.business_since">
                    </fg-input>
                </div> -->
                <div class="form-group">
                    <label>Funcionamiento desde</label>
                    <el-date-picker
                        format="dd/MM/yyyy"
                        v-model="form.customer.independent.business_since"
                        type="date"
                        placeholder="Seleccione fecha de inicio de funcionamiento">
                    </el-date-picker>
                </div>
                <div class="form-group">
                    <label>Tipo de local / Terreno</label>
                    <fg-input   tabindex="3"
                                name="tipo de local negocio cliente"
                                v-validate="modelValidations.customer.independent.business_local_type"
                                :error="getError('tipo de local negocio cliente')"
                                v-model="form.customer.independent.business_local_type">
                            <el-select 
                                    v-model="form.customer.independent.business_local_type"
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione">
                            <el-option class="select-warning"
                                    value = "Propio"
                                    label="PROPIO">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Familiar"
                                    label="FAMILIAR">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Alquilado"
                                    label="ALQUILADO">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <br>
                <div  class="row" style="margin: 0 0 12px;">
                    <p-checkbox v-model="form.customer.independent.business_home" value="1" :checked="false">Negocio en domicilio </p-checkbox>
                </div>
                <div v-if="!form.customer.independent.business_home" class="form-group">
                    <label>Dirección del negocio</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="dirección negocio de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.independent.business_address"
                                :error="getError('dirección negocio de cliente')"
                                v-model="form.customer.independent.business_address">
                    </fg-input>
                </div>
                <div v-if="!form.customer.independent.business_home" class="form-group">
                    <label>Departamento</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="departamento negocio cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.independent.business_state"
                                :error="getError('departamento negocio cliente')"
                                v-model="form.customer.independent.business_state">
                    </fg-input>
                </div>
                <div v-if="!form.customer.independent.business_home" class="form-group">
                    <label>Municipio</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="municipio negocio de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.independent.business_city"
                                :error="getError('municipio negocio de cliente')"
                                v-model="form.customer.independent.business_city">
                    </fg-input>
                </div>
                <div v-if="!form.customer.independent.business_home" class="form-group">
                    <label>Barrio</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="barrio negocio de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.independent.business_neighborhood"
                                :error="getError('barrio negocio de cliente')"
                                v-model="form.customer.independent.business_neighborhood">
                    </fg-input>
                </div>
                <div v-if="!form.customer.independent.business_home" class="form-group">
                    <label>Código</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="código barrio de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.independent.business_neighborhood_code"
                                :error="getError('código barrio de cliente')"
                                v-model="form.customer.independent.business_neighborhood_code">
                    </fg-input>
                </div>
                <div v-if="!form.customer.independent.business_home" class="form-group">
                    <label>Ubicación del negocio</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="ubicación negocio de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.independent.business_location"
                                :error="getError('ubicación negocio de cliente')"
                                v-model="form.customer.independent.business_location">
                    </fg-input>
                </div>
                <div v-if="!form.customer.independent.business_home" class="form-group">
                    <label>Teléfono fijo del negocio</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono negocio de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.independent.business_phone"
                                :error="getError('teléfono negocio de cliente')"
                                v-model="form.customer.independent.business_phone">
                    </fg-input>
                </div>
                <div v-if="!form.customer.independent.business_home" class="form-group">
                    <label>Teléfono celular</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="celular negocio de cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.independent.business_cellphone"
                                :error="getError('celular negocio de cliente')"
                                v-model="form.customer.independent.business_cellphone">
                    </fg-input>
                </div>
                <div v-if="form.customer.independent.business_local_type == 'Alquilado'" class="form-group">
                    <label>Nombre de arrendador</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="arrendador negocio cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.independent.business_house_lessor"
                                :error="getError('arrendador negocio cliente')"
                                v-model="form.customer.independent.business_house_lessor">
                    </fg-input>
                </div>
                <div v-if="form.customer.independent.business_local_type == 'Alquilado'" class="form-group">
                    <label>Teléfono del arrendador</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono arrendador negocio cliente"
                                autocomplete="off"
                                v-validate="modelValidations.customer.independent.business_house_lessor_phone"
                                :error="getError('teléfono arrendador negocio cliente')"
                                v-model="form.customer.independent.business_house_lessor_phone">
                    </fg-input>
                </div>
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button @click="saveData()" type="warning">Guardar</p-button>
                    <!-- <p-button @click="toPersonalData()" type="default" class="pull-left mb-3">Atrás</p-button> -->
                </div>
            </div>
        </card>
        <card v-if="(form.customer.civil_status == 'Unión Libre' || form.customer.civil_status == 'Casado') && showForm('Conyuge')" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title text-center">
                    Datos cónyuge o compañero permanente
                </h6>
                <div  class="alert alert-info text-center">
                    <span >Diligenciar únicamente para crédito y cuando el cónyuge no firma como codeudor o cuando firma y no aporta al crédito</span>
                </div>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Cónyuge firma crédito</label>
                    <fg-input   tabindex="1"
                                name="cónyuge firma"
                                v-validate="modelValidations.customer.spouse.spouse_signer"
                                :error="getError('cónyuge firma')"
                                v-model="form.customer.spouse.spouse_signer">
                            <el-select 
                                    v-model="form.customer.spouse.spouse_signer"
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione">
                            <el-option class="select-warning"
                                    value = "1"
                                    label="SI">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "2"
                                    label="NO">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Tipo de identificación </label>
                    <fg-input   tabindex="1"
                                name="tipo de identificación cónyuge"
                                v-validate="modelValidations.customer.spouse.spouse_identification_type"
                                :error="getError('tipo de identificación cónyuge')"
                                v-model="form.customer.spouse.spouse_identification_type">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="form.customer.spouse.spouse_identification_type">
                            <el-option v-for="identificationDocumentType in $store.getters.getIdentificationDocumentTypes" :key="identificationDocumentType.id"
                                    class="select-warning"
                                    :value="identificationDocumentType.id"
                                    :label="identificationDocumentType.name">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Número de identificación</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombre de cónyuge"
                                autocomplete="off"
                                v-validate="modelValidations.customer.spouse.spouse_identification_number"
                                :error="getError('nombre de cónyuge')"
                                v-model="form.customer.spouse.spouse_identification_number">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Primer nombre </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="primer nombre de cónyuge"
                                autocomplete="off"
                                v-validate="modelValidations.customer.spouse.spouse_first_name"
                                :error="getError('primer nombre de cónyuge')"
                                v-model="form.customer.spouse.spouse_first_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Segundo/tercer nombre </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="segundo nombre de cónyuge"
                                autocomplete="off"
                                v-validate="modelValidations.customer.spouse.spouse_second_first_name"
                                :error="getError('segundo nombre de cónyuge')"
                                v-model="form.customer.spouse.spouse_second_first_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Primer apellido </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="primer apellido de cónyuge"
                                autocomplete="off"
                                v-validate="modelValidations.customer.spouse.spouse_last_name"
                                :error="getError('primer apellido de cónyuge')"
                                v-model="form.customer.spouse.spouse_last_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Segundo apellido </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="segundo apellido de cónyuge"
                                autocomplete="off"
                                v-validate="modelValidations.customer.spouse.spouse_second_last_name"
                                :error="getError('segundo apellido de cónyuge')"
                                v-model="form.customer.spouse.spouse_second_last_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono celular </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="celular de cónyuge"
                                autocomplete="off"
                                v-validate="modelValidations.customer.spouse.spouse_phone"
                                :error="getError('celular de cónyuge')"
                                v-model="form.customer.spouse.spouse_phone">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Cónyuge vive con el titular</label>
                    <fg-input   tabindex="3"
                                name="convivencia"
                                v-validate="modelValidations.customer.spouse.spouse_husband_coexist"
                                :error="getError('convivencia')"
                                v-model="form.customer.spouse.spouse_husband_coexist">
                            <el-select 
                                    v-model="form.customer.spouse.spouse_husband_coexist"
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione">
                            <el-option class="select-warning"
                                    value = "1"
                                    label="SI">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "2"
                                    label="NO">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Oficio </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="oficio cónyuge"
                                autocomplete="off"
                                v-validate="modelValidations.customer.spouse.spouse_job"
                                :error="getError('oficio cónyuge')"
                                v-model="form.customer.spouse.spouse_job">
                    </fg-input>
                </div>
                <div v-if="form.customer.spouse.spouse_husband_coexist == '2'" class="alert alert-info text-center">
                    <span >Diligenciar únicamente cuando el cónyuge no viva con el titular</span>
                </div>
                <div v-if="form.customer.spouse.spouse_husband_coexist == '2'" class="form-group">
                    <label>Dirección de vivienda </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="dirección vivienda cónyuge"
                                autocomplete="off"
                                v-validate="modelValidations.customer.spouse.spouse_address"
                                :error="getError('dirección vivienda cónyuge')"
                                v-model="form.customer.spouse.spouse_address">
                    </fg-input>
                </div>
                <div v-if="form.customer.spouse.spouse_husband_coexist == '2'" class="form-group">
                    <label>Teléfono fijo de vivienda </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono fijo cónyuge"
                                autocomplete="off"
                                v-validate="modelValidations.customer.spouse.spouse_house_phone"
                                :error="getError('teléfono fijo cónyuge')"
                                v-model="form.customer.spouse.spouse_house_phone">
                    </fg-input>
                </div>
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button @click="saveData()" type="warning">Guardar</p-button>
                    <!-- <p-button @click="toPersonalData()" type="default" class="pull-left mb-3">Atrás</p-button> -->
                </div>
            </div>
        </card>
        <card v-if="showForm('Autorizaciones')" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title text-center">
                    Autorización de envío de información, notificaciones y correspondencia
                </h6>
            </div>
            <div class="card-body">
                <div  class="alert alert-info text-center">
                    <span >Envío de cartas y aviso de notificación a centrales de riesgo</span>
                </div>
                <div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.customer.authorizations.notifications.home" value="1" :checked="false">Vivienda </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.customer.authorizations.notifications.business" value="1" :checked="false">Negocio </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.customer.authorizations.notifications.labor" value="1" :checked="false">Laboral </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.customer.authorizations.notifications.email" value="1" :checked="false">Correo electrónico </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.customer.authorizations.notifications.sms" value="1" :checked="false">Mensaje de Texto (SMS) y multimedia (SMM) </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.customer.authorizations.notifications.all" value="1" :checked="false">Cualquiera de los canales utilizados por el Banco (opciones anteriores) </p-checkbox>
                    </div>
                </div>
                <div  class="alert alert-info text-center">
                    <span >Envío de información de productos y servicios</span>
                </div>
                <div>
                    <div class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.customer.authorizations.information.sms" value="1" :checked="false">Mensaje de Texto (SMS) y multimedia (SMM) </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.customer.authorizations.information.email" value="1" :checked="false">Correo electrónico </p-checkbox>
                    </div>
                </div>
                <div  class="alert alert-info text-center">
                    <span >Envío de reporte anual de costos totales</span>
                </div>
                <div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.customer.authorizations.anual_report.email" value="1" :checked="false">Correo electrónico </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.customer.authorizations.anual_report.bank" value="1" :checked="false">Cualquier Oficina del Banco </p-checkbox>
                    </div>
                </div>
                <div  class="alert alert-info text-center">
                    <span >Canales autorizados para gestión de cobranza</span>
                </div>
                <div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.customer.authorizations.collection.home" value="1" :checked="false">Vivienda (Aplica para modalidad microcrédito) </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.customer.authorizations.collection.business" value="1" :checked="false">Negocio (Aplica para modalidad microcrédito)</p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.customer.authorizations.collection.call" value="1" :checked="false">Llamada telefónica </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.customer.authorizations.collection.email" value="1" :checked="false">Correo electrónico </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.customer.authorizations.collection.sms" value="1" :checked="false">Mensaje de Texto (SMS), cualquier mensaje de datos y/u otra mensajería ajustada a la Ley 527/99</p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.customer.authorizations.collection.letter" value="1" :checked="false">Carta </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.customer.authorizations.collection.any" value="1" :checked="false">Cualquiera de las anteriores</p-checkbox>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button @click="saveData()" type="warning">Guardar</p-button>
                    <!-- <p-button @click="toPersonalData()" type="default" class="pull-left mb-3">Atrás</p-button> -->
                </div>
            </div>
        </card>
        <card v-if="showForm('Financiera')" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title text-center">
                    Información financiera
                </h6>
            </div>
            <div class="card-body">
                <!-- <div class="form-group">
                    <label>Ingresos mensuales </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="ingresos mensuales"
                                autocomplete="off"
                                v-validate="modelValidations.customer.financial_information.monthly_incomes"
                                :error="getError('ingresos mensuales')"
                                v-model="form.customer.financial_information.monthly_incomes">
                    </fg-input>
                </div> -->
                <div class="form-group">
                    <label>Ingresos mensuales</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="ingresos mensuales" v-validate="modelValidations.customer.financial_information.monthly_incomes" :error="getError('ingresos mensuales')" separator="." class="form-control" v-model="form.customer.financial_information.monthly_incomes"></vue-numeric>
                </div>
                <!-- <div class="form-group">
                    <label>Otros ingresos mensuales </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="otros ingresos mensuales"
                                autocomplete="off"
                                v-validate="modelValidations.customer.financial_information.other_monthly_incomes"
                                :error="getError('otros ingresos mensuales')"
                                v-model="form.customer.financial_information.other_monthly_incomes">
                    </fg-input>
                </div> -->
                <div class="form-group">
                    <label>Otros ingresos mensuales</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="otros ingresos mensuales" v-validate="modelValidations.customer.financial_information.other_monthly_incomes" :error="getError('otros ingresos mensuales')" separator="." class="form-control" v-model="form.customer.financial_information.other_monthly_incomes"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>¿Cuáles? </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="descripción otros ingresos mensuales"
                                autocomplete="off"
                                v-validate="modelValidations.customer.financial_information.other_monthly_incomes_description"
                                :error="getError('descripción otros ingresos mensuales')"
                                v-model="form.customer.financial_information.other_monthly_incomes_description">
                    </fg-input>
                </div>
                <!-- <div class="form-group">
                    <label>Total ingresos mensuales </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="total ingresos mensuales"
                                autocomplete="off"
                                v-validate="modelValidations.customer.financial_information.monthly_incomes_total"
                                :error="getError('total ingresos mensuales')"
                                v-model="form.customer.financial_information.monthly_incomes_total">
                    </fg-input>
                </div> -->
                <div class="form-group">
                    <label>Total ingresos mensuales</label>
                    <vue-numeric  :max=999999999999999 disabled currency="$" autocomplete="off" name="total ingresos mensuales" v-validate="modelValidations.customer.financial_information.monthly_incomes_total" :error="getError('total ingresos mensuales')" separator="." class="form-control" v-model="monthly_incomes_total_computed"></vue-numeric>
                </div>
                <!-- <div class="form-group">
                    <label>Total egresos mensuales </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="total egresos mensuales"
                                autocomplete="off"
                                v-validate="modelValidations.customer.financial_information.monthly_expenses_total"
                                :error="getError('total egresos mensuales')"
                                v-model="form.customer.financial_information.monthly_expenses_total">
                    </fg-input>
                </div> -->
                <div class="form-group">
                    <label>Total egresos mensuales</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="total egresos mensuales" v-validate="modelValidations.customer.financial_information.monthly_expenses_total" :error="getError('total egresos mensuales')" separator="." class="form-control" v-model="form.customer.financial_information.monthly_expenses_total"></vue-numeric>
                </div>
                <!-- <div class="form-group">
                    <label>Total activos </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="total activos"
                                autocomplete="off"
                                v-validate="modelValidations.customer.financial_information.active_total"
                                :error="getError('total activos')"
                                v-model="form.customer.financial_information.active_total">
                    </fg-input>
                </div> -->
                <div class="form-group">
                    <label>Total activos</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="total activos" v-validate="modelValidations.customer.financial_information.active_total" :error="getError('total activos')" separator="." class="form-control" v-model="form.customer.financial_information.active_total"></vue-numeric>
                </div>
                <!-- <div class="form-group">
                    <label>Total pasivos </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="total pasivos"
                                autocomplete="off"
                                v-validate="modelValidations.customer.financial_information.passive_total"
                                :error="getError('total pasivos')"
                                v-model="form.customer.financial_information.passive_total">
                    </fg-input>
                </div> -->
                <div class="form-group">
                    <label>Total pasivos</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="total pasivos" v-validate="modelValidations.customer.financial_information.passive_total" :error="getError('total pasivos')" separator="." class="form-control" v-model="form.customer.financial_information.passive_total"></vue-numeric>
                </div>
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button @click="saveData()" type="warning">Guardar</p-button>
                    <!-- <p-button @click="toPersonalData()" type="default" class="pull-left mb-3">Atrás</p-button> -->
                </div>
            </div>
        </card>
        <card v-if="showForm('Internacionales')" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title text-center">
                    Información de operaciones internacionales
                </h6>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Operaciones en moneda extranjera</label>
                    <fg-input   tabindex="3"
                                name="operaciones extranjeras"
                                v-validate="modelValidations.customer.international_operations.international_operations"
                                :error="getError('operaciones extranjeras')"
                                v-model="form.customer.international_operations.international_operations">
                            <el-select 
                                    v-model="form.customer.international_operations.international_operations"
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione">
                            <el-option class="select-warning"
                                    value = "1"
                                    label="SI">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "2"
                                    label="NO">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="form.customer.international_operations.international_operations == '1'" class="form-group">
                    <label>Tipo de operación</label>
                    <fg-input   tabindex="3"
                                name="tipo de operación"
                                v-validate="modelValidations.customer.international_operations.type"
                                :error="getError('tipo de operación')"
                                v-model="form.customer.international_operations.type">
                            <el-select 
                                    v-model="form.customer.international_operations.type"
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione">
                            <el-option class="select-warning"
                                    value = "Exportación"
                                    label="EXPORTACIÓN">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Importación"
                                    label="IMPORTACIÓN">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Giros"
                                    label="GIROS">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Inversiones"
                                    label="INVERSIONES">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "Otro"
                                    label="OTRO">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="form.customer.international_operations.international_operations == '1'" class="form-group">
                    <label>Tipo de producto </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="tipo de producto moneda extranjera"
                                autocomplete="off"
                                v-validate="modelValidations.customer.international_operations.product_type"
                                :error="getError('tipo de producto moneda extranjera')"
                                v-model="form.customer.international_operations.product_type">
                    </fg-input>
                </div>
                <div v-if="form.customer.international_operations.international_operations == '1'" class="form-group">
                    <label>Número del producto </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="número producto moneda extranjera"
                                autocomplete="off"
                                v-validate="modelValidations.customer.international_operations.product_number"
                                :error="getError('número producto moneda extranjera')"
                                v-model="form.customer.international_operations.product_number">
                    </fg-input>
                </div>
                <div v-if="form.customer.international_operations.international_operations == '1'" class="form-group">
                    <label>Nombre de la entidad </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombre de entidad moneda extranjera"
                                autocomplete="off"
                                v-validate="modelValidations.customer.international_operations.entity_name"
                                :error="getError('nombre de entidad moneda extranjera')"
                                v-model="form.customer.international_operations.entity_name">
                    </fg-input>
                </div>
                <div v-if="form.customer.international_operations.international_operations == '1'" class="form-group">
                    <label>Moneda </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="moneda extranjera"
                                autocomplete="off"
                                v-validate="modelValidations.customer.international_operations.currency"
                                :error="getError('moneda extranjera')"
                                v-model="form.customer.international_operations.currency">
                    </fg-input>
                </div>
                <!-- <div v-if="form.customer.international_operations.international_operations == '1'" class="form-group">
                    <label>Monto </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="monto moneda extranjera"
                                autocomplete="off"
                                v-validate="modelValidations.customer.international_operations.amount"
                                :error="getError('monto moneda extranjera')"
                                v-model="form.customer.international_operations.amount">
                    </fg-input>
                </div> -->
                <div v-if="form.customer.international_operations.international_operations == '1'" class="form-group">
                    <label>Monto</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="monto moneda extranjera" v-validate="modelValidations.customer.international_operations.amount" :error="getError('monto moneda extranjera')" separator="." class="form-control" v-model="form.customer.international_operations.amount"></vue-numeric>
                </div>
                <div v-if="form.customer.international_operations.international_operations == '1'" class="form-group">
                    <label>Ciudad </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="ciudad moneda extranjera"
                                autocomplete="off"
                                v-validate="modelValidations.customer.international_operations.city"
                                :error="getError('ciudad moneda extranjera')"
                                v-model="form.customer.international_operations.city">
                    </fg-input>
                </div>
                <div v-if="form.customer.international_operations.international_operations == '1'" class="form-group">
                    <label>País </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="país moneda extranjera"
                                autocomplete="off"
                                v-validate="modelValidations.customer.international_operations.country"
                                :error="getError('país moneda extranjera')"
                                v-model="form.customer.international_operations.country">
                    </fg-input>
                </div>
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button @click="finishData()" type="warning">Finalizar</p-button>
                    <!-- <p-button @click="toPersonalData()" type="default" class="pull-left mb-3">Atrás</p-button> -->
                </div>
            </div>
        </card>
        <!-- <fab
        :position="position"
        :bg-color="bgColor"
        :actions="fabActions"
        main-icon='search'
        icon-size="small"
        @toER="toER"
        ></fab> -->
    </div>
</template>
    <script>
    import fab from 'vue-fab'
    import { Card } from 'src/components/UIComponents'
    import Vue from 'vue'
    import {Select, Option, DatePicker, TimeSelect} from 'element-ui'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import moment from 'moment'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import { isEmpty } from 'lodash';
    import { parse } from 'expression-eval'
    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card,
            VueNumeric,
            PSwitch,
            fab,
            [DatePicker.name]: DatePicker,
            [TimeSelect.name]: TimeSelect,
        },
        data() {
        return {
            agro: false,
            bgColor: '#F09500',
            position: 'bottom-right',
            position2: 'top-right',
            fabActions: [
                {
                    name: 'toER',
                    icon: 'ER'
                }
            ],
            // customerFirstName: '',
            // customerSecondName: '',
            // customerSurname: '',
            // customerSecondSurname: '',
            // customerIdentificationNumber: '',
            // customerIdentificationType: '',
            modelValidationsCustomer: {
                customerFirstName: {
                    required: false,
                    max: 16
                },
                customerSecondName: {
                    required: false,
                    max: 16
                },
                customerSurname: {
                    required: false,
                    max: 16
                },
                customerSecondSurname: {
                    required: false,
                    max: 16
                },
                customerIdentificationNumber: {
                    required: false,
                    numeric: true,
                    max: 32
                },
                customerIdentificationType: {
                    required: false,
                },
            },
            modelValidations: {
                customer: {
                    country: {
                        required: true,
                        max: 16
                    },
                    state: {
                        required: true,
                        max: 32
                    },
                    city: {
                        required: true,
                        max: 32
                    },
                    date: {
                        required: true,
                    },
                    nationality: {
                        required: true,
                        max: 32
                    },
                    civil_status: {
                        required: true,
                        max: 32
                    },
                    people: {
                        required: true,
                        numeric: true
                    },
                    educational_level: {
                        required: true,
                        max: 32
                    },
                    principal_activity: {
                        required: true,
                        max: 32
                    },
                    ciiu: {
                        required: true,
                        max: 12
                    },
                    economic_description: {
                        required: false,
                        max: 64
                    },
                    disability_person: {
                        required: false
                    },
                    disability_description: {
                        required: false,
                        max: 64
                    },

                    // ocupation_category: {
                    //     required: true,
                    //     max: 32
                    // },
                    ocupation: {
                        required: true,
                        max: 32
                    },
                    job: {
                        required: true,
                        max: 32
                    },
                    activity_type: {
                        required: true,
                        max: 32
                    },
                    email: {
                        required: false,
                        regex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                        max: 64
                    },
                    address: {
                        required: false,
                        max: 120
                    },
                    stratum: {
                        required: true,
                        numeric: true,
                        max_value: 10
                    },
                    house_state: {
                        required: true,
                        max: 32
                    },
                    house_city: {
                        required: true,
                        max: 32
                    },
                    house_neighborhood: {
                        required: true,
                        max: 32
                    },
                    house_neighborhood_code: {
                        required: false,
                        max: 32
                    },
                    house_description:  {
                        required: false,
                        max: 32
                    },
                    house_phone: {
                        required: false,
                        numeric: true,
                        max: 12
                    },
                    house_celphone: {
                        required: false,
                        numeric: true,
                        max: 12
                    },
                    house_type: {
                        required: true,
                        max: 32
                    },
                    in_house_since: {
                        required: true,
                        max: 32
                    },
                    house_lessor: {
                        required: false,
                        max: 32
                    },
                    house_lessor_phone: {
                        required: false,
                        numeric: true,
                        max: 12
                    },
                    dependent: {
                        job: {
                            required: false,
                            max: 32
                        },
                        job_nit: {
                            required: false,
                            max: 16
                        },
                        job_name: {
                            required: false,
                            max: 32
                        },
                        job_state: {
                            required: false,
                            max: 32
                        },
                        job_city: {
                            required: false,
                            max: 32
                        },
                        job_neighborhood: {
                            required: false,
                            max: 32
                        },
                        job_neighborhood_code: {
                            required: false,
                            max: 32
                        },
                        job_phone: {
                            required: false,
                            numeric: true,
                            max: 12
                        },
                        job_address: {
                            required: false,
                            max: 120
                        },
                        contract_type: {
                            required: false,
                            max: 32
                        },
                        date: {
                            required: false,
                        },
                        job_description: {
                            required: false,
                            max: 32
                        },
                        job_boss: {
                            required: false,
                            max: 32
                        },
                        job_boss_phone: {
                            required: false,
                            numeric: true,
                            max: 12
                        }
                    },
                    independent: {
                        business_name: {
                            required: false,
                            max: 32
                        },
                        business_activity: {
                            required: false,
                            max: 128
                        },
                        business_ciiu: {
                            required: false,
                            max: 128
                        },
                        business_type_location: {
                            required: false,
                            max: 32
                        },
                        business_rural: {
                            required: false,
                            max: 32
                        }, 
                        business_since: {
                            required: false,
                            max: 32
                        },
                        business_local_type: {
                            required: false,
                            max: 32
                        },
                        business_home: {
                            required: false,
                            max: 32
                        },
                        business_state: {
                            required: false,
                            max: 32
                        },
                        business_city: {
                            required: false,
                            max: 32
                        },
                        business_neighborhood: {
                            required: false,
                            max: 32
                        },
                        business_neighborhood_code: {
                            required: false,
                            max: 32
                        },
                        business_phone: {
                            required: false,
                            numeric: true,
                            max: 12
                        },
                        business_cellphone: {
                            required: false,
                            numeric: true,
                            max: 12
                        },
                        business_address: {
                            required: false,
                            max: 120
                        },
                        business_location: {
                            required: false,
                            max: 64
                        },
                        business_house_lessor: {
                        required: false,
                        max: 32
                        },
                        business_house_lessor_phone: {
                            required: false,
                            numeric: true,
                            max: 12
                        },
                    },
                    spouse: {
                        spouse_signer: {
                            required: false,
                            max: 32
                        },
                        spouse_identification_type: {
                            required: false,
                            max: 64
                        },
                        spouse_identification_number: {
                            required: false,
                            numeric: true,
                            max: 32
                        },
                        spouse_second_first_name: {
                            required: false,
                            max: 32
                        },
                        spouse_first_name: {
                            required: false,
                            max: 32
                        },
                        spouse_second_last_name: {
                            required: false,
                            max: 32
                        },
                        spouse_last_name: {
                            required: false,
                            max: 32
                        },
                        spouse_phone: {
                            required: false,
                            numeric: true,
                            max: 12
                        },
                        spouse_husband_coexist: {
                            required: false,
                            max: 32
                        },
                        spouse_job: {
                            required: false,
                            max: 32
                        },
                        spouse_address: {
                            required: false,
                            max: 120
                        },
                        spouse_house_phone: {
                            required: false,
                            numeric: true,
                            max: 12
                        }
                    },
                    authorizations: {
                        notifications: {
                            home: {
                                required: false
                            },
                            business: {
                                required: false
                            },
                            labor: {
                                required: false
                            },
                            email: {
                                required: false
                            },
                            sms: {
                                required: false
                            },
                            all: {
                                required: false
                            },
                        },
                        information: {
                            sms: {
                                required: false
                            },
                            email: {
                                required: false
                            }
                        },
                        anual_report: {
                            email: {
                                required: false
                            },
                            bank: {
                                required: false
                            }
                        },
                        collection: {
                           home: {
                                required: false
                           },
                           business: {
                                required: false
                           },
                           call: {
                                required: false
                           },
                           email: {
                                required: false
                           },
                           sms: {
                                required: false
                           },
                           letter: {
                                required: false
                           },
                           any: {
                                required: false
                           }
                        }
                    },
                    financial_information: {
                        monthly_incomes: {
                            required: true
                        },
                        other_monthly_incomes: {
                            required: true
                        },
                        other_monthly_incomes_description: {
                            required: false,
                            max: 32
                        },
                        monthly_incomes_total: {
                            required: true
                        },
                        monthly_expenses_total: {
                            required: true
                        },
                        active_total: {
                            required: true
                        },
                        passive_total: {
                            required: true
                        }
                    },
                    international_operations: {
                        international_operations: {
                            required: false
                        },
                        type: {
                            required: false
                        },
                        product_type: {
                            required: false
                        },
                        product_number: {
                            required: false
                        },
                        entity_name: {
                            required: false
                        },
                        currency: {
                            required: false
                        },
                        amount: {
                            required: false
                        },
                        city: {
                            required: false
                        },
                        country: {
                            required: false
                        }
                    }
                }
            },
            form: {
                dependentForm: false,
                independentForm: false,
                spouseForm: false,
                authorizationsForm: false,
                financialForm: false,
                internationalForm: false,
                finished: false,
                customer: {
                    country: '',
                    state: '',
                    city: '',
                    // date: '',
                    date: Date.now(),
                    nationality: 'Colombiano',
                    civil_status: '',
                    people: '',
                    educational_level: '',
                    principal_activity: '',
                    ciiu: '',
                    // ocupation_category: '',
                    ocupation: '',
                    job: '',
                    activity_type: '',
                    email: '',
                    address: '',
                    stratum: '',
                    house_state: '',
                    house_city: '',
                    house_neighborhood: '',
                    house_neighborhood_code: '',
                    house_description:  '',
                    house_phone: '',
                    house_celphone: '',
                    house_type: '',
                    in_house_since: Date.now(),
                    house_lessor: '',
                    house_lessor_phone: '',
                    economic_description: '',
                    disability_person: '2',
                    disability_description: '',
                    dependent: {
                        job: '',
                        job_nit: '',
                        job_name: '',
                        job_state: '',
                        job_city: '',
                        job_neighborhood: '',
                        job_neighborhood_code: '',
                        job_phone: '',
                        job_address: '',
                        contract_type: '',
                        date: Date.now(),
                        job_description: '',
                        job_boss: '',
                        job_boss_phone: ''
                    },
                    independent: {
                        business_name: '',
                        business_activity: '',
                        business_ciiu: '',
                        business_type_location: '',
                        business_rural: false, 
                        business_since: '',
                        business_local_type: '',
                        business_home: false,
                        business_state: '',
                        business_city: '',
                        business_neighborhood: '',
                        business_neighborhood_code: '',
                        business_phone: '',
                        business_cellphone: '',
                        business_address: '',
                        business_location: '',
                        business_house_lessor: '',
                        business_house_lessor_phone: '',
                    },
                    spouse: {
                        spouse_signer: '',
                        spouse_identification_type: '',
                        spouse_identification_number: '',
                        spouse_second_first_name: '',
                        spouse_first_name: '',
                        spouse_second_last_name: '',
                        spouse_last_name: '',
                        spouse_phone: '',
                        spouse_husband_coexist: '2',
                        spouse_job: '',
                        spouse_address: '',
                        spouse_house_phone: ''
                    },
                    authorizations: {
                        notifications: {
                            home: false,
                            business: false,
                            labor: false,
                            email: false,
                            sms: false,
                            all: false,
                        },
                        information: {
                            sms: true,
                            email: false
                        },
                        anual_report: {
                            email: false,
                            bank: false
                        },
                        collection: {
                            home: false,
                            business: false,
                            call: false,
                            email: false,
                            sms: false,
                            letter: false,
                            any: false
                        }
                    },
                    financial_information: {
                        monthly_incomes: '',
                        other_monthly_incomes: '',
                        other_monthly_incomes_description: '',
                        monthly_incomes_total: '',
                        monthly_expenses_total: '',
                        active_total: '',
                        passive_total: ''
                    },
                    international_operations: {
                        international_operations: '2',
                        type: '',
                        product_type: '',
                        product_number: '',
                        entity_name: '',
                        currency: '',
                        amount: '',
                        city: '',
                        country: ''
                    }
                }
            },
            
        }
        },
        watch: {
            'form.customer.independent.business_rural': function (newVal) {
                if(newVal == true) {
                    this.form.customer.independent.business_type_location = '';
                }
            },
            'form.customer.principal_activity': function (newVal) {
                if(newVal == 'Dependiente-Empleado') {
                    this.modelValidations.customer.dependent.job.required = true;
                    this.modelValidations.customer.dependent.job_nit.required = true;
                    this.modelValidations.customer.dependent.job_name.required = true;
                    this.modelValidations.customer.dependent.job_state.required = true;
                    this.modelValidations.customer.dependent.job_city.required = true;
                    this.modelValidations.customer.dependent.job_neighborhood.required = true;
                    this.modelValidations.customer.dependent.job_phone.required = true;
                    this.modelValidations.customer.dependent.job_address.required = true;
                    this.modelValidations.customer.dependent.contract_type.required = true;
                }
                else {
                    this.modelValidations.customer.dependent.job.required = false;
                    this.modelValidations.customer.dependent.job_nit.required = false;
                    this.modelValidations.customer.dependent.job_name.required = false;
                    this.modelValidations.customer.dependent.job_state.required = false;
                    this.modelValidations.customer.dependent.job_city.required = false;
                    this.modelValidations.customer.dependent.job_neighborhood.required = false;
                    this.modelValidations.customer.dependent.job_phone.required = false;
                    this.modelValidations.customer.dependent.job_address.required = false;
                    this.modelValidations.customer.dependent.contract_type.required = false;
                }
            },
            'form.customer.independent.business_activity' : function(newVal, oldVal) {
                if (newVal != oldVal) {
                    for(let i=0;i<this.$store.getters.getEconomicActivities.length;i++) {
                        if(this.$store.getters.getEconomicActivities[i].name == newVal) {
                            this.form.customer.independent.business_ciiu = this.$store.getters.getEconomicActivities[i].code;
                        }
                    }
                }
            },
            'form.customer.independent.business_local_type' : function(newVal, oldVal) {
                if(newVal != 'Alquilado' &&  newVal != 'Alquilada') {
                    this.form.customer.independent.business_house_lessor = '';
                    this.form.customer.independent.business_house_lessor_phone = '';
                }
            },
            'form.customer.house_type' : function(newVal, oldVal) {
                if(newVal != 'Alquilado' &&  newVal != 'Alquilada') {
                    this.form.customer.house_lessor = '';
                    this.form.customer.house_lessor_phone = '';
                }
            },
            'form.customer.international_operations.international_operations': function(newVal, oldVal) {
                if(newVal != oldVal) {
                    this.form.customer.international_operations.type= '';
                    this.form.customer.international_operations.product_type= '';
                    this.form.customer.international_operations.product_number= '';
                    this.form.customer.international_operations.entity_name= '';
                    this.form.customer.international_operations.currency= '';
                    this.form.customer.international_operations.amount= '';
                    this.form.customer.international_operations.city= '';
                    this.form.customer.international_operations.country= '';
                }
            }

        },
        computed: {
            /**
             * Función para almacenar en vuex el nombre del cliente
             */
            customerFirstName: {
                get: function () {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerFirstName;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerFirstName;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].customerFirstName;
                    }
                },
                set: function (val) {
                    this.$store.commit('updateCustomerFirstName', val)
                }
            },
            /**
             * Función para almacenar en vuex el nombre del cliente
             */
            customerSecondName: {
                get: function () {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerSecondName;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerSecondName;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].customerSecondName;
                    }
                    
                },
                set: function (val) {
                    this.$store.commit('updateCustomerSecondName', val)
                }
            },
            /**
             * Función para almacenar en vuex el nombre del cliente
             */
            customerSurname: {
                get: function () {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerSurname;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerSurname;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].customerSurname;
                    }
                },
                set: function (val) {
                    this.$store.commit('updateCustomerSurname', val)
                }
            },
            /**
             * Función para almacenar en vuex el nombre del cliente
             */
            customerSecondSurname: {
                get: function () {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerSecondSurname;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerSecondSurname;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].customerSecondSurname;
                    }
                },
                set: function (val) {
                    this.$store.commit('updateCustomerSecondSurname', val)
                }
            },
            /**
             * Función para almacenar en vuex el número de identificación del cliente
             */
            customerIdentificationNumber: {
                get: function () {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerIdentificationNumber;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerIdentificationNumber;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].customerIdentificationNumber;
                    }
                },
                set: function (val) {
                    this.$store.commit('updateCustomerIdentificationNumber', val)
                }
            },
            /**
             * Función para almacenar en vuex el tipo de identificación del cliente
             */
            customerIdentificationType: {
                get: function () {
                    if (this.$store.state.isCustomer) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerIdentificationType;
                    }
                    else if(this.$store.state.isSpouse) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerIdentificationType;
                    }
                    else if(this.$store.state.isGuarantor) {
                        return this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].customerIdentificationType;
                    }
                },
                set: function (val) {
                    this.$store.commit('updateCustomerIdentificationType', val)
                }
            },
            /**
             * Función para almacenar en vuex el nombre del cliente
             */
            monthly_incomes_total_computed: {
                get: function () {
                    this.form.customer.financial_information.monthly_incomes_total = this.form.customer.financial_information.monthly_incomes + this.form.customer.financial_information.other_monthly_incomes;
                    return  this.form.customer.financial_information.monthly_incomes + this.form.customer.financial_information.other_monthly_incomes;
                },
                set: function () {

                }
            },
        },
        methods: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showForm (form) {
                if(form == 'Dependiente') {
                    if(this.form.dependentForm) {
                        return true
                    }
                    else {
                        return false
                    }
                }
                else if(form == 'Independiente') {
                    if(this.form.independentForm) {
                        return true
                    }
                    else {
                        return false
                    }
                }
                else if(form == 'Conyuge') {
                    if(this.form.spouseForm) {
                        return true
                    }
                    else {
                        return false
                    }
                }
                else if(form == 'Autorizaciones') {
                    if(this.form.authorizationsForm) {
                        return true
                    }
                    else {
                        return false
                    }
                }
                else if(form == 'Financiera') {
                    if(this.form.financialForm) {
                        return true
                    }
                    else {
                        return false
                    }
                }
                else if(form == 'Internacionales') {
                    if(this.form.internationalForm) {
                        return true
                    }
                    else {
                        return false
                    }
                }
                return false
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            changeCIIUIndependent(id) {
                console.info(id)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            validateStudy() {
                if(this.$store.state.isCustomer) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].productType);
                }
                else if(this.$store.state.isGuarantor) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[0].productType);
                }
                if (product.name.toLowerCase() == 'consumo') {
                    return 'consumer'
                }
                else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                    this.form.customer.principal_activity = 'Independiente';
                    return 'micro'
                }
                else if (product.name.toLowerCase() == 'pequeña empresa') {
                    this.form.customer.principal_activity = 'Independiente';
                    return 'pyme'
                }
                else if (product.name.toLowerCase() == 'agropecuario') {
                    this.form.customer.principal_activity = 'Independiente';
                    return 'agro'
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toFM102() {
                this.$router.push('/asessments/new_asessment/customer/fm102');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toER () { 
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /***
            * Función para mostrar un mensaje de éxito
            */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
                console.info(this.errors)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toMenu () {
                this.$router.push('/asessments/menu');
            },
            saveData () {
                this.form.finished = false;
                this.$store.dispatch('setFM100', this.$data).then(()=>{
                    if(this.form.dependentForm || this.form.independentForm) {
                        if(this.form.spouseForm) {
                            if(this.form.authorizationsForm) {
                                if(this.form.financialForm) {
                                    if(!this.form.internationalForm) {
                                        this.form.internationalForm = true;
                                    }
                                }
                                else {
                                    this.form.financialForm = true;
                                }
                            }
                            else {
                                this.form.authorizationsForm = true;
                            }
                        }
                        else {
                            this.form.spouseForm = true;
                            this.authorizationsForm = true;
                        }
                    }
                    else {
                        if(this.form.customer.principal_activity == 'Pensionado') {
                            this.form.spouseForm = true;
                            this.authorizationsForm = true;
                        }
                        this.form.dependentForm = true;
                        this.form.independentForm = true;
                    }
                    this.showNotificationSuccess('Información guardada correctamente en el dispositivo')
                });
            },
            finishData () {
                this.form.finished = false;
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.form.customer.date == '' || this.form.customer.date == null) {
                            this.showNotificationError('La fecha de nacimiento del titular es obligatoria');
                            return
                        }
                        if (this.form.customer.in_house_since == '' || this.form.customer.in_house_since == null) {
                            this.showNotificationError('La fecha (habitada desde) del titular es obligatoria');
                            return
                        }
                        if (this.form.customer.principal_activity == 'Dependiente-Empleado' && (this.form.customer.dependent.date == '' || this.form.customer.dependent.date == null)) {
                            this.showNotificationError('La fecha de ingreso en los datos laborales es obligatoria');
                            return
                        } 
                        this.form.finished = true;
                        this.$store.dispatch('setFM100', this.$data).then(()=>{
                            var payload = {
                                stage: 'Registro de Formulario',
                                description: 'Se ingresan datos del formulario FM100.',
                                dateTime: moment().format()
                            };
                            this.$store.dispatch('setChangeLog', payload).then(()=>{
                                if(!this.agro){
                                    this.$router.push('/asessments/menu');
                                }
                                else {
                                    this.$router.push('/asessments/new_asessment/customer/agro/inventory');
                                }
                            });
                        });
                    }
                    else {
                        this.showNotificationError('Algunos campos son erróneos, revisa y continúa');
                        // window.scroll(0, 0);
                        this.$el.querySelector('[name="' + this.$validator.errors.items[0].field + '"]').focus();
                    }
                })
            }
        },
        mounted() {
            // this.$store.state.isCustomer = true;
            this.$store.state.isSpouse = false;

            // this.customerFirstName = this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerFirstName;
            // this.customerSecondName = this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerSecondName;
            // this.customerSurname = this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerSurname;
            // this.customerSecondSurname = this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerSecondSurname;
            // this.customerIdentificationNumber = this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerIdentificationNumber;
            // this.customerIdentificationType = this.$store.state.assesments[this.$store.state.actualAssesment].customer.customerIdentificationType;
            this.form.customer.date = moment().subtract(18,'years').calendar();
            if(this.$store.state.isCustomer) {
                if(this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm100.length > 0) {
                    this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm100[0];
                    if(!this.$data.form.customer.authorizations.hasOwnProperty('collection')){
                        var collection =  {
                            home: false,
                            business: false,
                            call: false,
                            email: false,
                            sms: false,
                            letter: false,
                            any: false
                        };
                        this.$data.form.customer.authorizations.collection = collection;
                    }
                    
                }
                if (typeof this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse !== 'undefined' && !_.isEmpty(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse)) {
                    if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies.length == 1) {
                        this.form.customer.civil_status = 'Casado';
                        this.form.customer.spouse.spouse_identification_type = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerIdentificationType;
                        this.form.customer.spouse.spouse_identification_number = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerIdentificationNumber;
                        this.form.customer.spouse.spouse_second_first_name = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerSecondName;
                        this.form.customer.spouse.spouse_first_name = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerFirstName;
                        this.form.customer.spouse.spouse_second_last_name = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerSecondSurname;
                        this.form.customer.spouse.spouse_last_name = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerSurname;
                    }
                }
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].productType);
                if (product.name.toLowerCase() == 'consumo') {
                    this.form.customer.principal_activity = 'Dependiente-Empleado';
                    this.form.dependentForm = true;
                    this.modelValidations.customer.dependent.job.required = true;
                    this.modelValidations.customer.dependent.job_nit.required = true;
                    this.modelValidations.customer.dependent.job_name.required = true;
                    this.modelValidations.customer.dependent.job_state.required = true;
                    this.modelValidations.customer.dependent.job_city.required = true;
                    this.modelValidations.customer.dependent.job_neighborhood.required = true;
                    this.modelValidations.customer.dependent.job_phone.required = true;
                    this.modelValidations.customer.dependent.job_address.required = true;
                    this.modelValidations.customer.dependent.contract_type.required = true;
                }
                if(product.name.toLowerCase() == 'agropecuario'){
                    this.agro = true;
                }
            }
            else if(this.$store.state.isGuarantor) {
                if(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].fm100.length > 0) {
                    this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].fm100[0];
                    if(!this.$data.form.customer.authorizations.hasOwnProperty('collection')){
                        var collection =  {
                            home: false,
                            business: false,
                            call: false,
                            email: false,
                            sms: false,
                            letter: false,
                            any: false
                        };
                        this.$data.form.customer.authorizations.collection = collection;
                    }
                }
                var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[0].productType);
                if (product.name.toLowerCase() == 'consumo') {
                    this.form.customer.principal_activity = 'Dependiente-Empleado';
                    this.form.dependentForm = true;
                    this.modelValidations.customer.dependent.job.required = true;
                    this.modelValidations.customer.dependent.job_nit.required = true;
                    this.modelValidations.customer.dependent.job_name.required = true;
                    this.modelValidations.customer.dependent.job_state.required = true;
                    this.modelValidations.customer.dependent.job_city.required = true;
                    this.modelValidations.customer.dependent.job_neighborhood.required = true;
                    this.modelValidations.customer.dependent.job_phone.required = true;
                    this.modelValidations.customer.dependent.job_address.required = true;
                    this.modelValidations.customer.dependent.contract_type.required = true;
                }
                if(product.name.toLowerCase() == 'agropecuario'){
                    this.agro = true;
                }
            }
            else if(this.$store.state.isSpouse) {

            }
        },
        beforeDestroy() {
            
        }
        
    }
</script>
<style>
.fab-main .material-icons{
    color: black !important;
    background-color: #F09500 !important;
}
.fab-list li .material-icons{
    color: black !important;
    font-family: "Helvetica Neue" !important;
    font-size: 12px !important;
}
.center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
.orange {
    color: #F09500;
}
.white {
    color: white;
}
</style>
